import PropTypes from 'prop-types'
import { Copy, Download, Edit, Trash } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'
import DropDownMenu from '../../common/DropDownMenu'
import LinkWithStatus from '../../common/LinkWithStatus'
import { Menu } from '@styled-icons/boxicons-regular/Menu'

const CONNECTOR_MENU = [
  {
    name: 'Edit',
    value: 'edit',
    icon: <Edit size="1rem" />,
  },
  {
    name: 'Delete',
    value: 'delete',
    icon: <Trash size="1rem" />,
  },
  {
    name: 'Clone SVG',
    value: 'clone_svg',
    icon: <Copy size="1rem" />,
  },
]

const EXPORT_MENU = [
  ...CONNECTOR_MENU,
  ...[
    {
      name: 'Export SVG',
      value: 'export_svg',
      icon: <Download size="1rem" />,
    },
  ],
]

const ConnectorListRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-2/12 pl-2 items-center table_text">
          <Tooltip message={props?.name}>
            <div>{formatEmptyValue(props.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          {formatEmptyValue(props.category)}
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.description}>
            <div>{formatEmptyValue(props.description)}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          <Tooltip message={props?.device_data?.name}>
            <div>{formatEmptyValue(props.device_data?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          <Tooltip message={props?.alias}>
            <div>{formatEmptyValue(props.alias)}</div>
          </Tooltip>
        </div>
        <div className="w-1/12 pl-6">{formatEmptyValue(props.color)}</div>
        <div className="w-1/12 pl-6">
          {props.svg != null && props.svg != '' ? 'Yes' : 'No'}
        </div>

        <div className="w-1/12 pl-6">{formatEmptyValue(props.cavities)}</div>
        <div
          className={`w-1/12 pl-6 cursor-pointer ${props.location.length > 0 && 'underline'}`}
          onClick={() => {
            props.showVehicleView()
          }}
        >
          {props.location.length > 0 ? 'Yes' : 'No'}
        </div>

        <div className="flex w-1/12 pl-6 justify-end">
          <DropDownMenu
            items={props?.svg ? EXPORT_MENU : CONNECTOR_MENU}
            outsideClickClose={true}
            onClick={(value) => {
              if (value?.value === 'export_svg') {
                props.downloadSvgFile()
              } else if (value?.value === 'edit') {
                props.onEdit()
              } else if (value?.value === 'delete') {
                props.onDelete()
              } else if (value?.value === 'clone_svg') {
                props.onPartNumberSelect()
              }
            }}
          >
            <LinkWithStatus
              className="btn py-1 px-2"
              title="Delete"
              onClickFunc={() => {}}
            >
              <Menu size="1.5rem" color="white" />
            </LinkWithStatus>
          </DropDownMenu>
        </div>
      </div>
    </div>
  )
}

ConnectorListRow.propTypes = {
  name: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cavities: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  downloadSvgFile: PropTypes.func.isRequired,
  location: PropTypes.array,
  showVehicleView: PropTypes.func.isRequired,
}

export default ConnectorListRow
